import { AvitoStyles } from './AvitoStyles';
import { PARTNER_AFF_IDS } from 'constants/partners';

export const customPartnerThemePaletteConfig: Record<number, string> = {
    [PARTNER_AFF_IDS.AVITO]: AvitoStyles,
};
